<template>
    <div class="container pt-2">
        <PageTitle main="Orçamentos" sub="Orçamentos recebidos pelos clientes" />
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group>
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        class="textInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button variant="outline-secondary" class="botaoInput" :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-orcamentos" 
                class="text-center table table-sm" 
                :items="orcamentos.length>0?orcamentos:[]" 
                :fields="fields" 
                per-page="5"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="success" class="mr-2 btn-sm mb-1 btn-size" @click="openModal(data.item)">
                        <i class="fas fa-dollar-sign"></i>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1 btn-size" @click="remove(data.item)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="5"
                aria-controls="table-orcamentos"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group>
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        class="textInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button variant="outline-secondary" class="botaoInput" :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-orcamentos" 
                class="text-center table table-sm" 
                :items="orcamentos.length>0?orcamentos:[]" 
                :fields="fields" 
                per-page="5"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="success" class="mr-2 btn-sm mb-1 btn-size" @click="openModal(data.item)">
                        <i class="fas fa-dollar-sign"></i>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1 btn-size" @click="remove(data.item)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="5"
                aria-controls="table-orcamentos"
                first-number
                last-number
                align="center"
                >
                </b-pagination>
            </div>
        </div>
        <!-- MODAL PROPOSTA -->
        <b-modal id="modal-proposta" hide-footer>
            <template v-slot:modal-title>
                Dados do Transporte: {{ orcamento.codigo }}
            </template>
            <p>Cliente: {{ orcamento.cliente_nome }}</p>
            <hr>
            <p>Origem: {{ orcamento.origem_cep }} - {{ orcamento.origem }}</p>
            <p>Destino: {{ orcamento.destino_cep }} - {{ orcamento.destino }}</p>
            <hr>
            <p>Tipo de Carga: {{ orcamento.carga_titulo }}</p>
            <p v-if="orcamento.caminhao!=='0' && orcamento.caminhao!==undefined">Tipo de Caminhão: {{ orcamento.caminhao_titulo }}</p>
            <p v-else>Tipo de Caminhão: Não há especificação para este item!</p>
            <hr>
            <p v-if="orcamento.data_inicio!=='0000-00-00' && orcamento.data_inicio!==undefined">Previsão de Envio: {{ formatData(orcamento.data_inicio) }}</p>
            <p v-else>Previsão de Envio: Não há especificação para este item!</p>
            <p v-if="orcamento.data_final!=='0000-00-00' && orcamento.data_final!==undefined">Previsão de Entrega: {{ formatData(orcamento.data_final) }}</p>
            <p v-else>Previsão de Entrega: Não há especificação para este item!</p>
            <hr>
            <div class="row">
                <div class="col-md-12">
                    <b-form-group label="Valor da Proposta:" label-for="proposta-valor">
                        <b-form-input id="proposta-valor"
                            v-money="money"
                            v-model.lazy="proposta.valor"
                            class="textInput"/>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <b-button variant="success" block class="mt-3 botaoInput" @click="sendProposta">Enviar Proposta</b-button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <b-button variant="danger" block class="mt-3 botaoInput" @click="$bvModal.hide('modal-proposta')">Cancelar</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>

import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { VueEasyJwt } from 'vue-easy-jwt'
import { VMoney } from 'v-money'

export default {
    name: 'orcamentos',
    components: { PageTitle },
    directives: { money: VMoney },
    data: function() {
        return {
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            jwt: new VueEasyJwt(),
            orcamento: {},
            orcamentos: [],
            proposta: {},
            fields: [
                { key: 'codigo', label: 'Código', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'cliente_nome', label: 'Cliente', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'origem', label: 'Origem', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'destino', label: 'Destino', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'actions', label: 'Ações', thClass: 'tituloTabela', tdClass: 'actionsTabela' }
            ],
            larguraTela: 0,
            overflowValue: 'auto',
            level: '',
            quemRecebeu: '',
            nome: '',
            email: ''
        }
    },
    computed: {
        rows() {
            return this.orcamentos.length
        }
    },
    methods: {
        formatData(data) {
            const arr = data.split('-')
            const y = arr[0]
            const m = arr[1]
            const d = arr[2]
            return `${d}/${m}/${y}`
        },
        openModal(item){
            this.orcamento = item
            this.$bvModal.show('modal-proposta')
        },
        sendProposta(){
            this.proposta.orcamento = this.orcamento.id
            this.proposta.funcionario = this.quemRecebeu
            axios['post'](`${baseApiUrl}/backend/proposta_orcamento.php`, this.proposta)
            .then(() => {
                // const tipo = `?tipo=novoCliente`
                // const destinoEmail = `&destinoEmail=${this.email}`
                // const destinoNome = `&destinoNome=${this.nome}`
                // axios.get(`${baseApiUrl}/backend/mailCliente.php${tipo}${destinoEmail}${destinoNome}`).then({})

                this.$toasted.global.defaultSuccess({ message : 'Proposta enviada com sucesso!' })
                this.reset()
                this.$bvModal.hide('modal-proposta')
            })
            .catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
            })
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        loadOrcamentos() {
            const url = `${baseApiUrl}/backend/orcamentosAbertos.php`
            axios.get(url).then(res => {
                this.orcamentos = res.data
                if(this.orcamentos.length > 0) {
                    this.exibeRodape = false
                }else{
                    this.exibeRodape = true
                }
            })
        },
        reset() {
            this.proposta = {}
            this.orcamento = {}
            this.loadOrcamentos()
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
                this.quemRecebeu = decodedToken['data'].id
                this.nome = decodedToken['data'].nome
                this.email = decodedToken['data'].email
            }
        }
    },
    mounted() {
        this.validaLogin()
        if (this.level === 'cliente') {
            this.$router.push('/')
        }
        this.loadOrcamentos()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.orcamentos.length
    }
}
</script>

<style>
    
</style>